<div class="haendler-page">
    <ng-container *ngIf="isMobileScreen; else desktopHeader">
        <div class="list-title-row list-title-row--mobile">
            <button *ngIf="showReturnButton" mat-icon-button color="accent" (click)="goBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <h3 class="mobile-title">Meine Händler ({{ gefilterteHaendler?.length || 0 }})</h3>
            <span class="spacer"></span>
            <button [matMenuTriggerFor]="spaltenMenu" color="accent" mat-icon-button matTooltip="Spalten auswählen">
                <mat-icon>view_week</mat-icon>
            </button>
            <button (click)="anlegenHaendler()" color="accent" mat-icon-button [disabled]="!canEditHaendler">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </ng-container>
    <ng-template #desktopHeader>
        <div class="list-title-row">
            <kiene-page-header
                [showReturnButton]="showReturnButton"
                [ueberschrift]="'Meine Händler (' + (gefilterteHaendler?.length || 0) + ')'"
                [routeRelativeAlternative]="'../../'"
            ></kiene-page-header>
            <span class="spacer"></span>
            <button [matMenuTriggerFor]="spaltenMenu" color="accent" mat-icon-button matTooltip="Spalten auswählen">
                <mat-icon>view_week</mat-icon>
            </button>
            <button (click)="anlegenHaendler()" color="accent" mat-icon-button [disabled]="!canEditHaendler">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </ng-template>

    <mat-menu #spaltenMenu="matMenu">
        <div class="spalten-menu-content" (click)="$event.stopPropagation()">
            <button
                mat-menu-item
                *ngFor="let col of columns"
                [disabled]="!canToggleColumn(col)"
                (click)="$event.stopPropagation(); toggleColumn(col.key)"
            >
                <mat-icon>{{ col.visible ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                <span>{{ col.label }}</span>
            </button>
        </div>
    </mat-menu>

    <div style="margin-bottom: 12px">
        <mat-hint class="hinweis-text">
            <strong>Hinweis:</strong>
            <span>
                Neben Viehhändlern können auch allgemeine Kontakte (z.B. Abnehmer für den Abgang) gespeichert
                werden.</span
            >
        </mat-hint>
    </div>

    <div class="search-container">
        <mat-form-field appearance="outline" class="search-field">
            <mat-label>Händler durchsuchen...</mat-label>
            <input matInput placeholder="Nach Händler, VVVO, Adresse oder E-Mail suchen..." [formControl]="searchControl" />
            <span matSuffix class="search-suffix">
                <button mat-icon-button aria-label="Clear" *ngIf="searchControl.value" (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-icon class="search-suffix-icon">search</mat-icon>
            </span>
        </mat-form-field>
    </div>

    <div *ngIf="haendlerFehlt" style="margin-bottom: 12px">
        <mat-hint class="hinweis-text" style="display: flex; align-items: flex-start; justify-content: flex-start">
            <div>
                <span class="dot-warn"></span>
            </div>
            <div style="text-align: justify; margin-left: 6px">
                <span>
                    Es muss mind. ein H&auml;ndler hinterlegt werden, sonst ist keine Abgangsmeldung m&ouml;glich.</span
                >
            </div>
        </mat-hint>
    </div>

    <div class="mobile-cards" *ngIf="isMobileScreen && gefilterteHaendler?.length; else desktopOrEmpty">
        <div class="mobile-card" *ngFor="let h of gefilterteHaendler">
            <div class="mobile-card__header">
                <div class="mobile-card__title-wrap">
                    <div class="mobile-card__title">
                        {{ getCellValue(h, 'name') }}
                        <span class="default-haendler" *ngIf="h.viehhaendler_id == benutzerprofil.default_haendler_id">(Standard Händler)</span>
                    </div>
                </div>
                <button
                    mat-icon-button
                    class="options-button"
                    [matMenuTriggerFor]="haendlerMenu"
                    [matTooltip]="canEditHaendler ? 'Menü öffnen' : null"
                    [disabled]="!canEditHaendler"
                >
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #haendlerMenu="matMenu" xPosition="before" yPosition="below">
                    <button mat-menu-item (click)="editiereHaendler(h)" [disabled]="!canEditHaendler">
                        <mat-icon>edit</mat-icon>
                        <span>Bearbeiten</span>
                    </button>
                    <button mat-menu-item (click)="deleteHaendler(h)" [disabled]="!canEditHaendler">
                        <mat-icon>delete</mat-icon>
                        <span>Löschen</span>
                    </button>
                </mat-menu>
            </div>
            <div class="mobile-card__grid">
                <div class="mobile-card__item" *ngFor="let col of getVisibleColumns()">
                    <span class="mobile-card__label">{{ col.label }}</span>
                    <ng-container [ngSwitch]="col.key">
                        <a
                            *ngSwitchCase="'email'"
                            [href]="'mailto:' + h.email"
                            class="mobile-card__value"
                            [class.mobile-card__value--disabled]="!h.email"
                            [attr.tabindex]="h.email ? null : -1"
                        >
                            {{ getCellValue(h, col.key) }}
                        </a>
                        <span *ngSwitchDefault class="mobile-card__value">{{ getCellValue(h, col.key) }}</span>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <ng-template #desktopOrEmpty>
    <div #tableScrollContainer class="list-wrapper" (scroll)="onTableHorizontalScroll()" *ngIf="gefilterteHaendler?.length; else noHaendler">
        <div class="list-content" [style.min-width.px]="getDesktopMinWidthPx()">
            <div class="list-header" [ngStyle]="{ 'grid-template-columns': getGridTemplate() }">
                <span *ngFor="let col of getVisibleColumns()">{{ col.label }}</span>
                <span class="row-actions row-actions-header"></span>
            </div>
            <ng-container *ngFor="let h of gefilterteHaendler">
                <div class="list-row" [ngStyle]="{ 'grid-template-columns': getGridTemplate() }">
                    <span class="row-cell" *ngFor="let col of getVisibleColumns()">
                        <span class="mobile-field-label">{{ col.label }}:</span>
                        <ng-container [ngSwitch]="col.key">
                            <strong *ngSwitchCase="'name'">{{ getCellValue(h, col.key) }}</strong>
                            <ng-container *ngSwitchCase="'email'">
                                <a
                                    *ngIf="h.email; else noEmail"
                                    class="mobile-field-value"
                                    [href]="'mailto:' + h.email"
                                    (click)="$event.stopPropagation()"
                                >
                                    {{ h.email }}
                                </a>
                                <ng-template #noEmail>
                                    <span class="mobile-field-value">-</span>
                                </ng-template>
                            </ng-container>
                            <span *ngSwitchDefault class="mobile-field-value">{{ getCellValue(h, col.key) }}</span>
                        </ng-container>
                    </span>
                    <span class="row-actions">
                        <button
                            mat-icon-button
                            class="options-button"
                            [matMenuTriggerFor]="haendlerMenu"
                            [matTooltip]="canEditHaendler ? 'Menü öffnen' : null"
                            [disabled]="!canEditHaendler"
                        >
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #haendlerMenu="matMenu" xPosition="before" yPosition="below">
                            <button mat-menu-item (click)="editiereHaendler(h)" [disabled]="!canEditHaendler">
                                <mat-icon>edit</mat-icon>
                                <span>Bearbeiten</span>
                            </button>
                            <button mat-menu-item (click)="deleteHaendler(h)" [disabled]="!canEditHaendler">
                                <mat-icon>delete</mat-icon>
                                <span>Löschen</span>
                            </button>
                        </mat-menu>
                    </span>
                </div>
            </ng-container>
        </div>
    </div>
    </ng-template>
    <div
        #bottomScrollbar
        class="kiene-horizontal-scrollbar"
        [class.hidden]="!showHorizontalScrollbar"
        [style.left.px]="bottomScrollbarLeft"
        [style.width.px]="bottomScrollbarWidth"
        (scroll)="onBottomScrollbarScroll()"
    >
        <div class="kiene-horizontal-scrollbar-content" [style.width.px]="horizontalScrollWidth"></div>
    </div>

    <ng-template #noHaendler>
        <div class="empty-state">Keine Händler/Kontakte gefunden.</div>
    </ng-template>
</div>
